export const environment = {
  production: true,
  apiURL: "http://api.wide-eyes.it",
  apiURLSTAGING: "http://api-staging.wide-eyes.it",
  apiURLMapping: "http://mapping.prod.wide-eyes.net"
};
